import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../contexts/UserContext";
import LoadingLogo from "../components/LoadingLogo";
import "./style/Success.css";

const endpoint = process.env.REACT_APP_API_URL + "/check-stripe-session";

function Success() {
  const [params] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);
  const { tokens } = useUserContext();
  const navigate = useNavigate();

  useEffect(() => {
    
    const session_id = params.get("session_id");
    if (!session_id) {
      setError("Aucune session Stripe détectée");
      setLoading(false);
      return;
    }
    if (!tokens?.accessToken) {
      return;
    }
    setLoading(true);
    axios
      .get(`${endpoint}?session_id=${session_id}`, {
        headers: {
          Authorization: `Bearer ${tokens.accessToken}`,
        },
      })
      .then((res) => {
        setStatus(res.data.status);
      })
      .catch(() => {
        setError("Erreur lors de la validation du paiement");
      })
      .finally(() => setLoading(false));
  }, [params, tokens]);

  // Loader : pas de fond
  if (!tokens?.accessToken || loading) {
    return (
      <div className="success-loader-center">
        <LoadingLogo />
      </div>
    );
  }

  // Message d'erreur (affiché dans la même box que le succès)
  if (error) {
    return (
      <div className="success-upload-container">
        <div className="success-msg error">
          <span role="img" aria-label="erreur" style={{ fontSize: 34 }}>❌</span>
          <br />
          {error}
        </div>
      </div>
    );
  }

  // Succès : style gold + fond flouté comme upload-page-container
  if (status === "paid") {
    return (
      <div className="success-upload-container">
        <div className="success-msg success">
          <span
            role="img"
            aria-label="success"
            style={{ fontSize: 40, color: "#facc15" }}
          >🎉</span>
          <br />
          <span style={{ color: "#facc15", fontWeight: 600, fontSize: "1.27rem" }}>
            Paiement validé ! Merci pour votre achat.
          </span>
          <div style={{ marginTop: 30 }}>
            <div
              style={{
                color: "#fff",
                fontSize: "1.08rem",
                marginBottom: 12,
                letterSpacing: 0.2,
                fontWeight: 500,
              }}
            >
              Créez maintenant votre évènement !
            </div>
            <button
              className="btn btn-create-event"
              style={{
                background: "linear-gradient(90deg, #facc15 70%, #ffe98a 100%)",
                color: "#332d03",
                fontWeight: 700,
                border: "none",
                borderRadius: 999,
                padding: "13px 32px",
                fontSize: "1.11rem",
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(251,202,21,0.15)"
              }}
              onClick={() => navigate("/create-event")}
            >
              Créer un évènement
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Autre statut
  return (
    <div className="success-upload-container">
      <div className="success-msg info">
        Paiement non validé ou en attente.<br />
        Statut : <b>{status}</b>
      </div>
    </div>
  );
}

export default Success;
